// Français — langue de référence. Toute clé absente d'une autre langue retombe ici.
const s = (n) => (n > 1 ? "s" : "");
// A run of cards (A-2-3) never splits over two lines: a word joiner after each hyphen.
const run = (cards) => cards.replace(/-/g, "-⁠");

const fr = {
  meta: { title: "Rami Online — Le Rami en ligne, entre amis" },

  lang: {
    label: "Langue",
    switched: "Le jeu est maintenant en français 🇫🇷",
  },

  common: {
    brand: "Rami Online",
    lobby: "Lobby",
    error: "Erreur",
    loading: "Chargement…",
    cancel: "Annuler",
    or: "ou",
    back: "Retour",
    home: "Accueil",
    you: "Vous",
    me: "Moi",
    yes: "Oui",
    no: "Non",
    left: "Gauche",
    right: "Droite",
    pts: "{n} pts",
    playersCount: "{a}/{b} joueurs",
    networkRetry: "Erreur réseau, réessaie",
    connecting: "Connexion en cours…",
    // Google sign-in in the apps (lib/googleLogin.js).
    googleFailed: "La connexion avec Google n'a pas abouti. Réessaie.",
    // Title of the "draw pile on the left / right" choice (Landing, JoinRoom).
    piocheSide: "Position de la pioche",
    google: "Continuer avec Google",
    namePlaceholder: "Introduire ton prénom…",
    enterName: "Entrez votre prénom",
    joinArrow: "Rejoindre →",
    quit: "Quitter",
    join: "Rejoindre",
    inProgress: "En cours",
    eliminated: "Éliminé",
    threshold: "Seuil",
    elim: "Élim.",
    jokers: "Jokers",
    rematch: "Rejouer",
    rematchBadge: "Revanche",
    rematchWaiting: ({ n }) =>
      n > 1 ? "{names} attendent pour rejouer" : "{names} attend pour rejouer",
  },

  landing: {
    titlePre: "",
    titleMain: "Rami Online",
    subtitle: "entre amis",
    guestTitle: "Jouer en invité",
    // What becomes of the player's data, under each way in (owner's request).
    googleKeep: "Ton profil sur tous tes appareils : rang, stats, tapis",
    guestKept: "Profil gardé sur cet appareil seulement",
    // The guest this device keeps (lib/guestDevice.js): « Continuer en tant que Sami ».
    resumeAs: "Continuer en tant que",
    newGuest: "Nouveau profil invité",
    replaceWarn: "Le profil de {name} sera effacé, rang compris.",
    guestGone: "Ce profil invité n'existe plus : entre un prénom pour en créer un.",
    guestSub: "Rejoindre ou créer une partie",
    nameEnough: "Un prénom suffit pour rejoindre",
    continueArrow: "Continuer →",
    // Second step for a guest: the side of the draw pile (pictures of each choice).
    piocheHint: "Choisis de quel côté de l'écran se trouve la pioche pendant la partie.",
    connecting: "Connexion…",
    feat: {
      players: "2 à 4 joueurs",
      bots: "Bots IA intégrés",
      realtime: "Temps réel",
    },
  },

  lobby: {
    // The Lobby's tabs (components/lobby/): the mode tiles of « Jouer ».
    hub: {
      ongoing: "Partie en cours",
      onlineTag: "4 joueurs",
      onlineSub: "Trouve 3 adversaires en quelques secondes. Ça compte pour ton rang.",
      openTables: ({ n }) => (n === 0 ? "Aucune table ouverte" : n === 1 ? "1 table ouverte" : `${n} tables ouvertes`),
      friendsTitle: "Entre amis",
      friendsSub: "Ta table, tes règles, un code à partager",
      create: "Créer une table",
      yourTables: "Tes tables",
      trainingTitle: "Entraînement",
      trainingSub: "Sans effet sur ton rang",
      solo2: "1 contre 1",
      solo4: "4 joueurs",
      level: "Niveau des bots",
      learnTitle: "Apprendre à jouer",
      learnSub: "Les règles en 9 étapes, puis une partie d'essai",
      tablePreview: "Ta table, telle que tu la verras en jeu.",
    },
    // "Rejoindre avec un code" — third button next to "Créer une partie" and
    // "Jouer en ligne": a room code or an invite link.
    code: {
      button: "Rejoindre avec un code",
      placeholder: "Code ou lien d'invitation",
      notFound: "Partie introuvable — vérifie le code ou le lien",
      inProgress: "partie en cours",
    },
    solo1v1: "Solo 1v1",
    solo4: "Solo 4J",
    quitFirst: "Quittez votre partie en cours d'abord",
    create: "Créer une partie",
    createShort: "Créer",
    newGame: "Nouvelle partie",
    players: "Joueurs",
    nPlayers: "{n} joueurs",
    botsLabel: "Bots ({n} / {max} max)",
    nBots: ({ n }) => (n === 0 ? "Aucun bot" : `${n} bot${s(n)}`),
    botLevel: "Niveau des bots",
    level: { debutant: "Débutant 🐣", medium: "Intermédiaire 😏", legende: "Légende 🔥" },
    nJokers: "{n} Jokers",
    thresholdLabel: "Seuil initial",
    thresholdTip:
      "Score minimum requis pour poser vos combinaisons pour la première fois. En dessous de ce seuil, vous ne pouvez pas ouvrir le jeu.",
    elimLabel: "Score élim.",
    elimTip:
      "Un joueur est éliminé définitivement quand son score total dépasse cette valeur. Le dernier non-éliminé gagne ; à 4 joueurs, les 2 derniers gagnent, classés selon leur score.",
    rulesTitle: "Pénalités & règles",
    pureSeq: "Suite pure sans Joker requise",
    pureSeqTip:
      "Si activé, les combinaisons posées doivent contenir au moins une suite de même couleur sans joker.",
    pen: {
      standard: {
        label: "Pénalité standard",
        tip: "Points ajoutés au score d'un joueur qui commet une faute en cours de jeu — par exemple, il tente de poser ses cartes en estimant atteindre le seuil, puis annule son action.",
      },
      joker: {
        label: "Joker en main",
        tip: "Pénalité si le joueur a posé une partie de ses cartes mais n'a pas gagné la manche et tient encore des jokers en main.",
      },
      useful: {
        label: "Défausse carte utile",
        tip: "Pénalité si un joueur défausse une carte qui aurait pu compléter une combinaison déjà posée sur la table.",
      },
      continuer: {
        label: "Pénalité « Continuer »",
        tip: "Pénalité pour le joueur qui a choisi de continuer la manche et qui n'a ni posé une partie de ses cartes ni gagné la manche.",
      },
      nefrechFausse: {
        label: "Manche gagnée sur défausse adverse",
        tip: "Pénalité appliquée lorsque vous défaussez une carte qui est récupérée par le joueur suivant pour gagner la manche.",
      },
    },
    createInvite: "Créer et inviter",
    // Closes the "Nouvelle partie" window without creating anything.
    createCancel: "Annuler",
    playOnline: "Jouer en ligne",
    play: "Jouer",
    searching: "Recherche…",
    privateTitle: "Salles privées",
    privateDesc:
      "Créez une partie privée, invitez vos amis via un lien et configurez les règles selon vos préférences.",
    chip: {
      link: "Invitation par lien",
      rules: "Règles personnalisables",
      friends: "2 à 4 amis",
      active: "Active tant qu'un joueur est connecté",
      botReplace: "Déconnexion remplacée par un bot",
      players4: "4 joueurs",
      instant: "Accès immédiat",
      realtime: "Temps réel",
    },
    resume: "Reprendre →",
    presetDefault: "Défaut",
    presetCustom: "Perso",
    viewParams: "Voir les paramètres",
    copyLink: "Copier le lien",
    linkCopied: "Lien copié !",
    // A room was just created: its code is in the clipboard (Lobby.handleCreate).
    codeCopied: "Code {code} copié : envoie-le à tes amis 📲",
    full: "Complet",
    noPrivate: "Aucune salle privée ouverte",
    noPrivateSub: "Créez une partie et partagez le lien à vos amis",
    onlineTitle: "Parties en ligne",
    available: "{n} dispo",
    onlineDesc:
      "Rejoignez une partie à 4 joueurs en temps réel. Le matchmaking vous place automatiquement dans une salle.",
    hostJokers: "{host} · {n} jokers",
    spotsLeft: ({ n }) => `${n} place${s(n)} libre${s(n)}`,
    noOnline: "Aucune salle en attente",
    noOnlineSub: 'Cliquez sur "Jouer" pour créer une nouvelle salle',
    param: {
      std: "Pénalité std",
      jokerHand: "Joker en main",
      useful: "Défausse utile",
      continuer: "Continuer",
      nefrechFausse: "Gagnée sur défausse",
      pureSeq: "Séq. pure",
    },
    toast: {
      matchmaking: "Erreur de matchmaking",
      create: "Erreur de création",
      quit: "Vous avez quitté la partie",
      solo: "Partie solo lancée contre {n} bot(s)",
    },
  },

  // Tutorial ("Tutoriel" in the Lobby header → components/tutorial). One idea
  // per step: a title, two lines, at most one tip. The rules quoted are the
  // default ones (seuil 71, pénalités de 50): keep them in step with backend/game.
  tuto: {
    button: "Tutoriel",
    title: "Le Rami en 1 minute",
    next: "Suivant",
    skip: "Passer",
    done: "C'est compris !",
    close: "Fermer",
    hand: "Ta main",
    who: { leila: "Leïla", sami: "Sami" },
    goal: {
      title: "Le premier qui finit gagne",
      body: "Chacun reçoit 14 cartes, et en a 15 après avoir pioché. Pose <b>14 cartes</b> en combinaisons de 3 cartes minimum, puis défausse la <b>15e</b> pour <b>gagner la manche</b>.",
      tip: "On joue à 2 ou à 4. Une partie se joue en plusieurs manches.",
      win: "Manche gagnée !",
    },
    turn: {
      title: "Ton tour en 3 temps",
      // The two gestures of the game: the draw pile is tapped, a card is dragged onto the discard pile.
      body: "<b>Appuie sur la pioche</b> pour piocher, <b>pose</b> tes combinaisons si tu peux, puis <b>glisse</b> une carte sur la défausse pour finir ton tour.",
      tip: "Si tu prends la dernière carte défaussée, tu dois faire ta première pose avec elle : tu verras comment dans les étapes suivantes.",
    },
    combos: {
      title: "Les combinaisons",
      body: "<b>Suite</b> : au moins 3 cartes qui se suivent, de la même couleur. <b>Brelan</b> : 3 ou 4 cartes de même valeur, de couleurs différentes.",
      tip: `L'As se place avant le 2 (${run("A-2-3")}) ou après le Roi (${run("Q-K-A")}), jamais au milieu (${run("K-A-2")}).`,
      seq: "Suite",
      set: "Brelan",
    },
    joker: {
      title: "Le Joker",
      body: "Il remplace <b>n'importe quelle carte</b>. Sur la table, tu peux le récupérer en posant la vraie carte à sa place : il revient dans ta main. Dans une suite, <b>deux Jokers ne se suivent jamais</b>.",
      tip: "Un Joker encore en main à la fin de la manche coûte 50 points.",
    },
    // Why the first pose matters, and how the round is won. French and English
    // say "sauver / gagner la manche", not Nemna3 / Nefrech (owner's choice).
    save: {
      title: "Sauve ta manche, puis gagne-la",
      body: "Tant que tu n'as rien posé, la manche peut te coûter <b>100 points</b>. Ta première pose te <b>sauve</b> : tu ne comptes plus que les cartes de ta main. Ensuite, pose-les toutes et défausse la dernière pour <b>gagner la manche</b>.",
      tip: "Tu peux aussi tout poser d'un coup, en un seul tour : tu gagnes direct.",
      ifEnds: "Si la manche finit là",
      none: "Rien posé",
      saved: "Manche sauvée",
      won: "Manche gagnée",
    },
    nemna3: {
      title: "Comment sauver ta manche ?",
      body: "Dès ton 2e tour, tu peux poser. La 1re fois, il faut atteindre le <b>seuil</b> (affiché en haut), avec une <b>suite sans Joker</b> si les règles de la partie l'exigent (« Infos »). Après toi, le seuil monte.",
      tip: `Valeurs : 2 à 9 = leur chiffre · 10, J, Q, K = 10 · As = 1 dans ${run("A-2-3")}, sinon 10 · Joker = la carte qu'il remplace.`,
      pure: "Suite sans Joker",
    },
    table: {
      title: "Ensuite : complète la table",
      body: "Après ta première pose, ajoute tes cartes sur <b>toutes</b> les combinaisons de la table, même celles des autres, et prends la défausse librement.",
      warn: "Défausser une carte qui pouvait aller sur la table coûte 50 points.",
    },
    score: {
      title: "Fin de manche",
      body: "Le gagnant marque 0. Les autres comptent leurs cartes en main, et qui n'a rien posé prend <b>100</b>. Qui atteint le score d'élimination sort : le dernier en jeu gagne. À 4 joueurs, les 2 derniers gagnent, le plus petit score devant.",
      tip: "Début de manche : si tout le monde vote « Rejouer », on redistribue. Dès qu'un joueur dit « Continuer », on joue — et s'il ne pose rien, il prend 50 points de plus.",
    },
    ready: {
      title: "À toi de jouer !",
      body: "Le plus simple pour apprendre : une partie contre un bot débutant. Le Dealer te dit quoi faire à chaque tour.",
      // Same step when the tutorial opens by itself at the start of the first game.
      bodyGame: "Ta partie commence ! Le <b>Dealer</b>, en bas à gauche, te dit quoi faire à chaque tour. Touche-le pour voir l'historique de la partie dans son <b>journal</b>.",
      practice: "S'entraîner contre un bot",
    },
  },

  room: {
    addBots: "Ajouter des bots",
    role: { bot: "Bot IA", host: "Hôte", player: "Joueur" },
    waitingSlot: "En attente…",
    start: "Lancer",
    // The host's button while seats are still free: the game is played by those seated.
    startWith: "Lancer à {n} joueurs",
    waitingCount: "En attente ({a}/{b})",
    waitingLaunch: "En attente du lancement…",
    waitingTitle: "En attente des joueurs",
    shareHint: "Donne le code à tes amis, ou ajoute des bots",
    // Short code shown in the waiting room, typed on the home page to join.
    codeLabel: "Code de la partie",
    // The same, in the chip of the top bar (a phone's width).
    codeShort: "Code",
    codeCopied: "Code copié",
    cantStart: "Impossible de démarrer",
    cantLaunch: "Impossible de lancer",
    rematchNote: "Mêmes joueurs, mêmes règles",
    // Colour of the game table, each player's own (lib/tableThemes.js).
    table: {
      title: "Tapis de la table",
      names: {
        "emeraude": "Émeraude",
        "bleu-nuit": "Bleu nuit",
        "bordeaux": "Bordeaux",
        "mediterranee": "Méditerranée",
        "noir-or": "Noir & Or",
        "neon": "Néon",
      },
    },
  },

  // Shared by both waiting rooms (components/room/WaitingTable.jsx and its users).
  waitingTable: {
    full: "Table complète !",
    missing: ({ n }) => (n === 1 ? "Plus qu'un joueur et c'est parti !" : `Encore ${n} joueurs et c'est parti`),
    hostStarts: "Lance la partie quand tu veux",
    waitHost: "L'hôte va lancer la partie",
    noRank: "Sans autre joueur, pas de points de rang",
    // Under the count in the middle of the table ("2/4").
    atTable: "à table",
    startsIn: "Début dans",
    ready: "Prêt",
    starting: "Lancement…",
    tipTitle: "Le savais-tu ?",
    // « Le savais-tu ? » (Tips in WaitingTable.jsx), in this order. They follow the room's rules:
    // {n} = the room's penalty; a tip whose rule is off in the room is not shown.
    tips: {
      joker: "Le Joker remplace n'importe quelle carte. Sur la table, pose la vraie carte à sa place : il revient dans ta main.",
      noPose: "Tant que tu n'as rien posé, la manche peut te coûter 100 points. Ta première pose te sauve.",
      ace: `L'As se place avant le 2 (${run("A-2-3")}) ou après le Roi (${run("Q-K-A")}), jamais au milieu.`,
      usefulDiscard: "Défausser une carte qui pouvait aller sur la table coûte {n} points.",
      jokerHand: "Un Joker encore en main à la fin de la manche coûte {n} points.",
      pureSeq: "Ta première pose doit contenir une suite sans Joker.",
      threshold: "Chaque première pose fait monter le seuil : la suivante devra faire plus de points.",
      takeDiscard: "Tant que tu n'as rien posé, prendre la défausse t'oblige à faire ta première pose avec cette carte.",
      addToTable: "Après ta première pose, ajoute tes cartes sur toutes les combinaisons de la table, même celles des autres.",
      continuer: "Début de manche : dès qu'un joueur dit « Continuer », on joue. S'il ne pose rien, il prend {n} points de plus.",
      botReplace: "Si un joueur se déconnecte, un bot peut prendre sa place : la partie continue.",
      jokersApart: "Dans une suite, deux Jokers ne se suivent jamais : 5-6-7 avec deux Jokers se pose Joker-5-6-7-Joker.",
    },
  },

  // Waiting room of « Jouer en ligne », with strangers (components/room/OnlineWaitingRoom.jsx).
  onlineRoom: {
    searching: "Recherche de joueurs",
    startsSoon: "Installe-toi, la partie va commencer",
    seatSearching: "Recherche…",
    elapsed: "Temps d'attente",
    cta: {
      waiting: "En attente de joueurs ({a}/{b})",
      startNow: "Lancer maintenant",
      startsIn: ({ n }) => `Lancement dans ${n} s`,
    },
    bots: {
      ask: "Commence vite avec des bots",
      fill: "Compléter avec des bots",
    },
  },

  // Colours of the table locked behind a video (components/TableColorPicker.jsx).
  tableColor: {
    button: "Tapis",
    title: "Couleur de la table",
    lockedLabel: "{name} : verrouillée, regarder une vidéo pour la débloquer",
    hintApp: "Le vert est toujours libre. Regarde une courte vidéo pour débloquer une autre couleur.",
    hintWeb: "Le vert est toujours libre. Les autres couleurs se débloquent dans l'app Rami Online, avec une courte vidéo.",
    appOnly: "Cette couleur se débloque dans l'app Rami Online, avec une courte vidéo.",
    unlocked: "Tapis {name} débloqué",
    dismissed: "Vidéo interrompue : regarde-la jusqu'au bout pour débloquer la couleur.",
    noVideo: "Pas de vidéo disponible pour le moment. Réessaie dans un instant.",
    saveError: "Le déblocage n'a pas pu être enregistré. Vérifie ta connexion.",
  },

  join: {
    invited: "Vous êtes invité",
    nameEnough: "Un prénom suffit pour rejoindre la partie",
    gameOf: "Partie de",
    status: { started: "En cours", full: "Complète", open: "En attente" },
    invalidLink: "Lien invalide",
    invalidLinkDesc: "Cette salle n'existe plus ou le lien a expiré.",
    connectingGame: "Connexion à la partie…",
    fullTitle: "Salle complète",
    fullDesc: "Tous les joueurs ont rejoint — cette partie est sur le point de commencer.",
    refresh: "Actualiser",
    startedTitle: "Partie en cours",
    startedDesc: "La partie a déjà commencé. Rejoins la prochaine manche en créant une partie.",
    cantJoin: "Impossible de rejoindre la salle",
    googleSub: "Stats sauvegardées entre les parties",
  },

  game: {
    loading: "Chargement de la partie…",
    // The turn timer (TurnRing, BottomActions, Game.jsx): the Dealer at 10 s left, time given back, the last seconds.
    timer: {
      hurry: "⏳ Plus que 10 secondes !",
      bonus: "+{n} s",
      secs: "{n} s",
    },
    ws: {
      quit: "❌ {name} a quitté la partie définitivement",
    },
    ev: {
      voteCast: "↺ {name} veut rejouer ({a}/{b})",
      voteCastNext: "↺ {name} veut rejouer ({a}/{b}) — au tour de {next}",
      continuer: "▶ {name} a choisi de continuer la manche",
      redealDone: "↺ Manche rejouée ! Nouvelles cartes distribuées.",
      redealCancelled: "La manche continue — rejouer annulé ({names} avaient voté)",
    },
    turn: {
      draw: "✋ Votre tour — cliquez sur la pioche ou prenez la défausse",
      // Quand la défausse ne peut pas être prise (premier tour, première
      // défausse du joueur précédent, défausse verrouillée ou vide).
      drawOnly: "✋ Votre tour — piochez (la défausse n'est pas disponible ce tour-ci)",
      act: "🃏 Posez des groupes ou glissez une carte vers la défausse",
      // Premier tour du joueur dans la manche : il ne peut pas encore poser.
      discardOnly: "🃏 Premier tour : pas de pose, glissez une carte vers la défausse",
    },
    // Relances du Dealer quand le joueur laisse traîner son tour : une phrase
    // tirée au hasard. Une liste vide désactive la relance dans cette langue.
    // `drawOnly` sert quand la défausse ne peut pas être prise : ne pas y
    // inviter à la prendre.
    nudge: {
      draw: [
        "⏳ Tu dors ? 😴 Pioche une carte !",
        "⏳ Les autres t'attendent… à toi de piocher !",
        "⏳ Le café refroidit pendant que tu réfléchis ☕",
        "⏳ C'est ton tour depuis un moment… joue !",
        "⏳ N'aie pas peur, la carte ne mord pas 😄",
        "⏳ Tes amis ont pris un coup de vieux en t'attendant 👴",
        "⏳ Allô ? Il y a quelqu'un ? C'est à toi ! 📞",
        "⏳ La pioche ne va pas s'enfuir, mais tes amis oui 😅",
        "⏳ La bonne carte t'attend peut-être dans la pioche 😉",
        "⏳ Le thé est froid et la table s'impatiente 🍵",
        "⏳ Le match est fini et tu n'as toujours pas pioché ⚽",
        "⏳ Même le serveur du café t'attend 😅",
        "⏳ Le tour ne passera pas tout seul… pioche !",
        "⏳ Tu réfléchis à quoi ? Tu n'as même pas pioché ! 😄",
        "⏳ Ton voisin bâille… pioche donc ! 🥱",
        "⏳ Une carte avant la fin de la nuit, ce serait bien 🌙",
        "⏳ Allez champion, pioche ou prends la défausse !",
        "⏳ Pioche ou défausse, mais choisis ton camp ! 😄",
        "⏳ La pioche te fait de l'œil… 😉",
        "⏳ Toute la table retient son souffle 😮",
        "⏳ Une petite carte pour commencer ?",
        "⏳ Le Dealer tapote la table… à toi ! 🃏",
        "⏳ Même les Jokers s'ennuient 🤡",
        "⏳ On a le temps de commander un deuxième café ☕☕",
        "⏳ La partie ne se jouera pas sans toi !",
        "⏳ Ta main attend sa quinzième carte 🖐️",
        "⏳ Un petit effort : une carte, et c'est parti !",
      ],
      drawOnly: [
        "⏳ Tu dors ? 😴 Pioche une carte !",
        "⏳ Les autres t'attendent… à toi de piocher !",
        "⏳ Le café refroidit pendant que tu réfléchis ☕",
        "⏳ C'est ton tour depuis un moment… joue !",
        "⏳ N'aie pas peur, la carte ne mord pas 😄",
        "⏳ Tes amis ont pris un coup de vieux en t'attendant 👴",
        "⏳ Allô ? Il y a quelqu'un ? C'est à toi ! 📞",
        "⏳ La pioche ne va pas s'enfuir, mais tes amis oui 😅",
        "⏳ La bonne carte t'attend peut-être dans la pioche 😉",
        "⏳ Le thé est froid et la table s'impatiente 🍵",
        "⏳ Le match est fini et tu n'as toujours pas pioché ⚽",
        "⏳ Même le serveur du café t'attend 😅",
        "⏳ Le tour ne passera pas tout seul… pioche !",
        "⏳ Tu réfléchis à quoi ? Tu n'as même pas pioché ! 😄",
        "⏳ Ton voisin bâille… pioche donc ! 🥱",
        "⏳ Une carte avant la fin de la nuit, ce serait bien 🌙",
        "⏳ La défausse est fermée ce tour-ci… reste la pioche ! 😄",
        "⏳ La pioche te fait de l'œil… 😉",
        "⏳ Toute la table retient son souffle 😮",
        "⏳ Une petite carte pour commencer ?",
        "⏳ Le Dealer tapote la table… à toi ! 🃏",
        "⏳ Même les Jokers s'ennuient 🤡",
        "⏳ On a le temps de commander un deuxième café ☕☕",
        "⏳ La partie ne se jouera pas sans toi !",
        "⏳ Ta main attend sa quinzième carte 🖐️",
        "⏳ Un petit effort : une carte de la pioche, et c'est parti !",
        "⏳ Ce tour-ci, c'est la pioche… vas-y ! 🃏",
      ],
      act: [
        "⏳ Défausse une carte et libère-nous ! 😅",
        "⏳ On t'attend… tu poses ou tu défausses ?",
        "⏳ Tu as assez réfléchi, joue maintenant !",
        "⏳ Le serveur a apporté le café et tu réfléchis encore ☕",
        "⏳ Allez, défausse une carte et termine ton tour",
        "⏳ Les cartes ne vont pas changer toutes seules 😄",
        "⏳ Tes amis vont s'endormir… défausse ! 😴",
        "⏳ Tu peux poser ? Pose. Sinon, défausse !",
        "⏳ Ce n'est pas des échecs, c'est du rami ! ♟️",
        "⏳ La nuit est longue, la manche non… allez !",
        "⏳ La carte chauffe dans ta main… défausse-la ! 🔥",
        "⏳ Une suite en main ? Pose-la, ne la cache pas 😏",
        "⏳ La carte parfaite n'existe pas… défausse ! 🤷",
        "⏳ Le Joker ne viendra pas en réfléchissant 😄",
        "⏳ Le temps file et tes cartes n'ont pas bougé ⏰",
        "⏳ La table va recommander des cafés… défausse ! ☕",
        "⏳ Bien compté ? Alors défausse-en une 😅",
        "⏳ Pose tes combinaisons ou défausse, la table s'impatiente 😄",
        "⏳ Toute la table compte tes cartes avec toi 🧮",
        "⏳ Le Dealer commence à bâiller 🥱",
        "⏳ Une décision, une seule : laquelle défausser ? 🤔",
        "⏳ Tes adversaires préparent déjà leur revanche 😏",
        "⏳ Les cartes, c'est mieux sur la table qu'en main 😉",
        "⏳ On t'a gardé une place… mais pas toute la nuit 🌙",
        "⏳ Même le Joker a fait son choix, et toi ? 🤡",
        "⏳ Respire, choisis, défausse ! 😌",
        "⏳ Le café du voisin est déjà fini ☕",
      ],
      // Premier tour : on ne peut que défausser — ne pas inviter à poser.
      discardOnly: [
        "⏳ Défausse une carte et libère-nous ! 😅",
        "⏳ Tu as assez réfléchi, joue maintenant !",
        "⏳ Le serveur a apporté le café et tu réfléchis encore ☕",
        "⏳ Allez, défausse une carte et termine ton tour",
        "⏳ Les cartes ne vont pas changer toutes seules 😄",
        "⏳ Tes amis vont s'endormir… défausse ! 😴",
        "⏳ Ce n'est pas des échecs, c'est du rami ! ♟️",
        "⏳ La nuit est longue, la manche non… allez !",
        "⏳ La carte chauffe dans ta main… défausse-la ! 🔥",
        "⏳ La carte parfaite n'existe pas… défausse ! 🤷",
        "⏳ Le Joker ne viendra pas en réfléchissant 😄",
        "⏳ Le temps file et tes cartes n'ont pas bougé ⏰",
        "⏳ La table va recommander des cafés… défausse ! ☕",
        "⏳ Bien compté ? Alors défausse-en une 😅",
        "⏳ Premier tour : une seule chose à faire, défausser ! 🃏",
        "⏳ Pas de pose ce tour-ci… choisis une carte et défausse-la 😉",
        "⏳ Toute la table compte tes cartes avec toi 🧮",
        "⏳ Le Dealer commence à bâiller 🥱",
        "⏳ Une décision, une seule : laquelle défausser ? 🤔",
        "⏳ Tes adversaires préparent déjà leur revanche 😏",
        "⏳ On t'a gardé une place… mais pas toute la nuit 🌙",
        "⏳ Respire, choisis, défausse ! 😌",
        "⏳ Le café du voisin est déjà fini ☕",
        "⏳ Une carte en trop dans ta main… laquelle ? 🃏",
        "⏳ Défausse et la manche est lancée ! 🚀",
        "⏳ Choisis ta carte la moins utile et au revoir ! 👋",
      ],
    },
    hint: {
      draw: "Piochez une carte ou prenez la défausse",
      drawOnly: "Piochez une carte",
      pending: ({ n }) => `${n} combinaison${s(n)} · glissez vers la défausse`,
      act: "Défaussez ou posez des combinaisons",
      discardOnly: "Premier tour : défaussez une carte",
      lastCard: "Défaussez votre dernière carte pour gagner la manche",
      belowThreshold: ({ n, missing }) =>
        `${n} combinaison${s(n)} · il manque ${missing} pt${s(missing)} pour poser`,
      needPureSeq: ({ n }) => `${n} combinaison${s(n)} · il faut une suite sans Joker`,
    },
    err: {
      select3: "Sélectionnez au moins 3 cartes",
      invalidCombo: "Combinaison invalide",
      validation: "Erreur de validation",
      max14Cancelled:
        "Maximum 14 cartes peuvent être posées par tour. Ce groupe a été annulé ({n} tentées).",
      max14: "Maximum 14 cartes peuvent être posées par tour ({n} tentées).",
      keepOne: "Gardez au moins 1 carte en main pour défausser.",
      fausseEmpty: "La Fausse est vide",
      notYourTurn: "Ce n'est pas votre tour",
      alreadyDrewTurn: "Vous avez déjà pioché ce tour-ci",
      alreadyDrew: "Vous avez déjà pioché",
      discardLocked:
        "La défausse est verrouillée ce tour-ci (joueur précédent éliminé). Piochez depuis la pioche.",
      discardClosed: "La défausse n'est pas disponible ce tour-ci. Piochez depuis la pioche.",
      oneCardDiscard: "Une seule carte à la fois pour la défausse",
      drawFirst: "Vous devez d'abord piocher une carte avant de défausser",
      jokerPosUnknown: "Impossible de déterminer la position du Joker.",
      jokerNoSlot: "Impossible d'ajouter un Joker à cette suite : aucune position légale.",
      jokerNoSlotBothEnds:
        "Impossible d'ajouter un Joker à cette suite : aucune position légale (ni avant ni après).",
      jokersSideBySide: "Deux Jokers ne peuvent pas se suivre dans une suite.",
      jokerCantAdd: "Impossible d'ajouter ce Joker à cette suite.",
      invalidWithCards: "Combinaison invalide avec ces cartes",
      cantAddNow: "Vous ne pouvez pas ajouter en ce moment",
      groupFull: "Ce groupe est complet (4 cartes) — aucun ajout possible",
      poseFirstForJoker:
        "Posez d'abord des groupes (≥ {n} pts) pour pouvoir récupérer ce Joker",
      // Shown only when the room requires a sequence without a Joker.
      pureSeqForJoker: "Il faut une suite sans Joker dans vos groupes pour récupérer ce Joker",
      replaceImpossible2: "Remplacement impossible avec ces 2 cartes",
      jokerInPendingGroup: "Ce Joker est dans un groupe en préparation : retirez ce groupe avant d'annuler.",
      jokerInvalidSeq: "Joker invalide dans cette suite",
      additionInvalid: "Ajout invalide",
      neitherReplaceNorExtend: "Cette carte ne peut ni remplacer le Joker ni étendre la suite.",
      cantPoseNow: "Vous ne pouvez pas poser en ce moment",
      min3: "Au moins 3 cartes pour un groupe",
    },
    ok: {
      cardTaken: "Carte prise",
      stagedTaken: "Carte récupérée — composez votre première pose incluant cette carte",
      cancelled: "Action annulée",
      nemna3CancelledPenalty: "Nemna3 annulé — +{n} pts de pénalité",
      jokerUndo: "↩ Récupération du Joker annulée",
      modsUndone: "↩ Modifications annulées",
      jokerLeft: "Joker inséré à gauche",
      jokerRight: "Joker inséré à droite",
      jokerLeftAuto: "Joker inséré à gauche (auto)",
      jokerRightAuto: "Joker inséré à droite (auto)",
      jokerLeftPending: "Joker inséré à gauche (en attente)",
      jokerRightPending: "Joker inséré à droite (en attente)",
      jokerRecoveredReal: "Joker récupéré — carte réelle positionnée",
      jokerRecovered: "♻️ Joker récupéré !",
      addedToGroup: "+{n} carte(s) ajoutée(s) au groupe",
      pendingAdd: "+{n} carte(s) en attente d'ajout",
      cardsAdded: "{n} carte(s) ajoutée(s)",
      autoNefrech: "🏆 Manche gagnée !",
    },
  },

  top: {
    paramsTitle: "Paramètres de la partie",
    thresholdInit: "Seuil initial",
    elimScore: "Score élim.",
    pureSeqReq: "Suite pure requise",
    penStd: "Pénalité std",
    jokerHand: "Joker en main",
    usefulDiscard: "Défausse utile",
    continuer: "Continuer",
    nefrechFausse: "Gagnée sur défausse",
    disabled: "Désactivé",
    round: "Manche {n}",
    threshold: "Seuil: {n}",
    infos: "Infos",
    soundOn: "Activer le son des joueurs",
    soundOff: "Couper le son des joueurs",
    music: "Musique",
    musicOn: "Activer la musique",
    musicOff: "Couper la musique",
    // The mood each table colour plays (lib/music.js, MOODS).
    moods: {
      emeraude: "Café jazz",
      "bleu-nuit": "Nuit étoilée",
      bordeaux: "Salon velours",
      neon: "Synthwave",
      "noir-or": "Casino noir",
      mediterranee: "Andalou",
    },
  },

  pioche: {
    draw: "Piochez",
    discard: "Défaussez",
    pile: "Pioche",
    pileCount: "Pioche ({n})",
    take: "Prendre",
    closed: "Fermée",
    discardLabel: "Défausse",
    fausse: "Fausse",
    fausseCount: "Fausse ({n})",
    taken: "Prise",
    drag: "Glisser",
    dropHere: "Glissez ici",
    empty: "Vide",
    cancel: "Annuler",
  },

  table: {
    set: "Br",
    seq: "Su",
    preparing: "⏳ {name} prépare…",
    cancelAdd: "Annuler ajout",
    swap: "♻ Échange",
    addedAndJoker: "Cartes ajoutées + Joker récupéré",
    nAdded: "{n} carte(s) ajoutée(s)",
    jokerRecovered: "Joker récupéré",
    modsPending: "Modifications en cours",
    undo: "Annuler",
    drop3: "Glisser 3+ cartes",
  },

  bottom: {
    yourTurn: "Votre tour",
    continuer: "Continuer",
    relancer: "Relancer",
    nCards: "{n} cartes",
    sortBy: "Trier",
    sortValue: "Valeur",
    sortSuit: "Couleur",
    emoji: "Envoyer un emoji",
  },

  feed: {
    aria: "Journal de partie",
    dealer: "Le Dealer",
    title: "Le Dealer · Journal",
    empty: "Aucun événement pour l'instant…",
  },

  // The Lobby's Profil tab (components/lobby/ProfileTab.jsx).
  profile: {
    title: "Mon profil",
    name: "Ton nom",
    nameHint: "C'est le nom que les autres voient à la table.",
    avatar: "Ton avatar",
    googlePhoto: "Photo Google",
    initial: "Initiale",
    save: "Enregistrer",
    saved: "Profil enregistré ✓",
    close: "Fermer",
    google: "Compte Google",
    guest: "Compte invité",
    guestNote: "Ton profil invité est gardé sur cet appareil. Connecte-toi avec Google pour le retrouver sur un autre.",
    saveError: "Le profil n'a pas pu être enregistré. Réessaie dans un moment.",
    card: "Ta carte de joueur",
    record: ({ g, w, l }) => `${g} partie${g > 1 ? "s" : ""} · ${w} V · ${l} D`,
    account: "Compte",
    avatars: {
      wolf: "Loup", goldlion: "Lion d'or", eagle: "Aigle", cobra: "Cobra", scorpion: "Scorpion", skull: "Tête de mort",
      nvg: "Opérateur", reticle: "Viseur", ace: "As ailé", king: "Roi", joker: "Joker", rank: "Grade",
    },
  },

  // The rank (lib/ranks.js, components/rank/): points won or lost in each game, from Bronze to Maître.
  rank: {
    title: "Rang",
    tabs: { me: "Mon rang", board: "Classement", recent: "Récents" },
    tiers: { bronze: "Bronze", argent: "Argent", or: "Or", platine: "Platine", diamant: "Diamant", maitre: "Maître" },
    pr: "{n} PR",
    gain: "+{n} PR",
    drop: "−{n} PR",
    calibrating: "Calibrage",
    calibrationCount: "{n}/{total} parties",
    calibrationNote: "Tes {n} premières parties avec d'autres joueurs comptent double. Ton rang apparaît ensuite.",
    toNext: "{n} PR avant {rank}",
    top: "Le plus haut rang",
    stats: {
      games: "Parties",
      wins: "Victoires",
      losses: "Défaites",
      winRate: "% de victoires",
      streak: "Série en cours",
      bestStreak: "Meilleure série",
      roundsWon: "Manches gagnées",
      abandons: "Abandons",
      peak: "Meilleur rang",
    },
    last: "Dernière partie",
    ladder: "Les rangs",
    how: {
      title: "Comment ça marche ?",
      place: "Une partie te fait gagner ou perdre des points de rang (PR), selon ta place à la table.",
      humans: "Elle compte si au moins 2 joueurs réels la commencent, même si tu finis avec les bots. Contre des bots seuls : ni points, ni stats.",
      winners: "À 4 joueurs, la partie a 2 gagnants, classés selon leur score : le 1er prend plus de points que le 2e.",
      strength: "Battre plus fort que toi rapporte plus, perdre contre plus faible coûte plus. Les bots de la table comptent selon leur niveau.",
      kept: "Un rang atteint est acquis : tu ne redescends jamais en dessous.",
      quit: "Quitter une partie en cours compte comme une défaite, avec 10 PR de plus.",
    },
    guestNote: "Profil invité : ton rang est gardé sur cet appareil. Connecte-toi avec Google pour le retrouver partout.",
    board: {
      you: "Toi",
      position: "Ta place : {n}",
      unranked: "Termine ton calibrage pour entrer au classement.",
      empty: "Personne n'est encore classé. À toi de jouer !",
      error: "Classement indisponible pour le moment.",
    },
    card: { record: "{w} V · {l} D", open: "Voir mon rang" },
    change: {
      win: "Victoire",
      winSecond: "Victoire · 2e",
      loss: "{place}e sur {of}",
      abandon: "Abandon",
      promoted: "Promotion !",
      newTier: "Nouveau rang !",
      placed: "Rang obtenu",
      calibration: "Calibrage {n}/{total}",
    },
  },

  // Another player's card (components/players/PlayerCardDialog.jsx).
  players: {
    title: "Profil du joueur",
    status: { online: "En ligne", in_game: "En partie", offline: "Hors ligne" },
    guest: "Compte invité",
    you: "C'est toi !",
    invite: "Inviter à jouer",
    invited: "Invitation envoyée ✓",
    waitNote: "Ton invitation l'attendra 10 minutes dans le Lobby.",
    finishGame: "Termine ta partie pour l'inviter.",
    sameTable: "Déjà à ta table.",
    notFound: "Ce joueur n'existe plus.",
    error: "Une erreur est survenue. Réessaie dans un moment.",
    recentEmpty: "Les joueurs de tes prochaines parties apparaîtront ici.",
    open: "Voir le profil de {name}",
  },

  // An invitation received, in the Lobby (components/players/InviteBanner.jsx).
  invite: {
    title: "{name} t'invite à jouer",
    sub: "Une table entre amis t'attend",
    expires: "encore {n} min",
    join: "Rejoindre",
    decline: "Refuser",
    quitFirst: "Quitte ta partie en cours pour rejoindre.",
    error: "Cette invitation n'est plus valable.",
    more: ({ n }) => (n === 1 ? "+1 autre invitation" : `+${n} autres invitations`),
    seatPending: "Invité",
    seatDeclined: "A refusé",
  },

  // The Lobby's categories (components/lobby/LobbyTabBar.jsx) and its settings sheet.
  nav: { label: "Menu principal", play: "Jouer", rank: "Rang", social: "Social", table: "Table", profile: "Profil" },
  settings: {
    title: "Paramètres",
    sound: "Effets sonores",
    tutorial: "Revoir le tutoriel",
    privacy: "Confidentialité",
    logout: "Se déconnecter",
  },
  social: {
    invites: "Invitations",
    noInvites: "Aucune invitation pour l'instant. Quand un joueur t'invite, elle arrive ici.",
    recent: "Joueurs récents",
    inviteHint: "Invite un joueur : ta table l'attend 10 minutes dans son Lobby.",
    invite: "Inviter",
    sent: "Envoyée",
  },

  account: {
    delete: "Supprimer mon compte",
    deleteTitle: "Supprimer ton compte ?",
    deleteBody: "Ton compte, ton nom et tes tapis débloqués seront effacés pour de bon. Si tu es dans une partie, tu la quittes. On ne peut pas revenir en arrière.",
    deleteConfirm: "Supprimer définitivement",
    deleteError: "Le compte n'a pas pu être supprimé. Réessaie dans un moment.",
  },

  redeal: {
    title: "Rejouer la manche ?",
    question: "Tes cartes te plaisent ?",
    lookHand: "Regarde bien tes {n} cartes avant de choisir",
    rejouer: "Rejouer",
    rejouerHint: "Nouvelles cartes",
    continuer: "Continuer",
    continuerHint: "Je garde mes cartes",
    stake: "Quand tu choisis Continuer et ne poses rien : +{n} pts",
    thinking: "{name} réfléchit…",
    youVoted: "Tu as dit Rejouer",
    turnSoon: "Ton tour de voter arrive",
    chose: "{name} a choisi de continuer",
    ok: "OK",
  },

  summary: {
    gameOver: "🏆 Partie terminée",
    roundOver: "Manche {n} terminée",
    gameWin: "{name} remporte la partie !",
    roundWin: "{name} a <b>gagné la manche</b> !",
    nefrechBadge: "Manche gagnée ✓",
    notPosed: "Pas posé",
    winningCombos: "Combinaisons gagnantes",
    kind: { sequence: "Suite", set: "Brelan / Carré" },
    discarded: "Carte défaussée",
    posedCombos: "Combinaisons posées",
    remaining: "Cartes restantes ({n})",
    nextRound: "Manche suivante",
    waitHost: "Manche suivante : en attente de {name}",
    host: "l'hôte",
    noWinner: "Pas de gagnant pour cette manche",
    backLobby: "Retour au lobby",
  },

  winner: {
    funny: [
      // Epic / légendaire
      "Tu n'as pas gagné un match, tu as donné une leçon. 🃏",
      "Les légendes ne se font pas, elles se révèlent — tu viens de te révéler. 👑",
      "Ce n'était pas une partie, c'était une masterclass. Prochaine session : payante. 💰",
      "Tu as posé tes cartes comme d'autres posent des œuvres d'art. Intouchable. 🖼️",
      "Dans 10 ans, on parlera encore de cette partie. 🏛️",
      "La table t'appartient. Les cartes le savaient depuis le début. 🎴",
      "Comme dit le sage : gagne bien qui gagne le dernier. 🎴",

      // Humble flex
      "On dit que la chance sourit aux audacieux. Toi, tu n'as pas besoin de chance. 😏",
      "Tes adversaires ont joué de leur mieux. C'est là tout le problème. 💀",
      "Résultat : toi 1, tous les autres 0. C'est mathématique. 📐",
      "Tu as gagné si facilement qu'on se demande si tu étais vraiment concentré. 😴",
      "Pendant qu'ils comptaient leurs cartes, tu comptais déjà tes points de victoire. 🧮",
      "Ta victoire était si nette que même l'arbitre applaudit. 👏",
      "Les cartes parlent, et ce soir, elles ont raconté ton histoire. ✨",

      // Funny / savage
      "Tes adversaires vont analyser leurs erreurs pendant des heures… et trouver d'autres excuses. 😅",
      "Champion officiel ! Ils demandent une revanche — spoiler : ça finira pareil. 😈",
      "Même les bots s'inclinent devant ta maîtrise du Rami. 🤖",
      "Les autres joueurs te regardent différemment maintenant… avec respect et jalousie. 😤",
      "Personne ne t'a vu venir… et c'est exactement ça, le style. 😎",
      "Ils cherchent encore où tu as caché ton as dans ta manche. 🃏",
      "On va changer le nom du jeu : « Rami de [TON NOM] ». 📝",
      "Ils ont tenté leur chance. Toi, t'as juste joué au Rami. 🤷",
      "Victoire méritée, humilité optionnelle. 🏆",
      "Tu défausses les autres comme un professionnel du tapis vert. 🎰",

      // Poétique / dramatique
      "Ce n'est pas une victoire, c'est une démonstration de domination absolue. 🔥",
      "Tu as lu le jeu comme un livre ouvert. Les autres n'étaient même pas au même chapitre. 📖",
      "Ta main était bénie, ton cerveau aussi. Respect total. 🧠",
      "Quand tu joues, les autres apprennent. Ils devraient te remercier. 🎓",
      "Les bots ont calculé toutes les probabilités. Aucune ne prévoyait quelqu'un d'aussi fort. 🤖",
      "Ce soir, tu n'as pas joué aux cartes. Tu les as maîtrisées. 🎴",
    ],
    champion: "CHAMPION !",
    subtitle: "Champion de Rami Online",
    second: "2E PLACE !",
    secondSubtitle: "Tu gagnes aussi cette partie",
    secondLine: "Deux places sur le podium, et tu en as une. La prochaine fois, celle du haut !",
    ranking: "Classement final",
    eliminated: "éliminé",
    closing: "Fermeture…",
    backLobby: "↩ Retour au lobby",
  },

  joker: {
    title: "Position du Joker",
    left: "← gauche",
    right: "droite →",
  },

  opp: {
    replaceBot: "Remplacer par bot",
    bot: "BOT",
    offline: "Déco",
    // Let two turns in a row run out (the turn timer): short turns until they play again.
    away: "Absent",
    awayTitle: "A laissé passer son temps : ses tours sont courts jusqu'à son retour",
    // Watching a rewarded video to unlock a table colour (POST /ad-break).
    watchingAd: "Pub couleur",
    watchingAdTitle: "Regarde une pub pour débloquer une couleur de table",
    // Tag under the name of the player who chose "Continuer" at the redeal vote.
    continuer: "A gardé la donne",
    continuerTitle: "A choisi de continuer au lieu de redistribuer : pénalité s'il ne pose pas avant la fin de la manche",
    cards: ({ n }) => `{n} carte${s(n)}`, // {n} stays: tRich puts the bold number there
    fausse: "+Fausse",
    elimSuffix: " · Éliminé",
    nefrechInProgress: "⚡ {name} gagne la manche…",
    preparing: "🃏 {name} prépare sa pose…",
    addsExisting: "+{n} carte(s) dans groupes existants",
  },

  score: { title: "Scores" },

  voice: {
    unsupported: "Micro non supporté sur ce navigateur",
    insecure: "Micro indisponible : connexion non sécurisée (HTTPS requis)",
    on: "Micro activé",
    denied: "Permission refusée. Autorisez le micro dans les paramètres du navigateur.",
    notFound: "Aucun micro détecté sur cet appareil.",
    busy: "Micro déjà utilisé par une autre application.",
    inaccessible: "Micro inaccessible ({reason})",
    unknown: "erreur inconnue",
    off: "Micro désactivé",
    enable: "Activer le micro",
    disable: "Désactiver le micro",
    lost: "Micro interrompu. Touchez l'icône pour le réactiver.",
    held: "Micro en pause (utilisé par le système)",
    linkConnecting: "Connexion vocale en cours…",
    failNetwork: "Voix impossible avec {name} : vos réseaux bloquent la connexion directe.",
    failSilent: "Voix impossible avec {name} : son appareil ne répond pas. Il doit recharger la page.",
    failOutdated: "Voix impossible avec {name} : sa page n'est pas à jour. Il doit la recharger.",
    details: "Détails",
    reportTitle: "Diagnostic vocal",
    reportHint: "Rapport technique de la liaison vocale. Copiez-le et envoyez-le au support.",
    refresh: "Actualiser",
    copy: "Copier",
    copied: "Rapport copié",
  },

  notif: { yourTurn: "C'est ton tour ! (Manche {n})" },
};

export default fr;
